import React from 'react';
import styled from '@emotion/styled';

const QtyWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  position: relative;
`;

const Quantity = styled.input`
  position: absolute;
  color: transparent;
  background-color: transparent;
  outline: none;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
`;

const QuantityLabel = styled.label`
  font-size: 32px;
  color: #41474f;
  letter-spacing: 0.36px;
  padding: 0 24px;
  min-width: 100px;
  text-align: center;
  line-height: 38px;
`;

const QuantityButton = styled.div`
  background-color: #1c232c;
  color: #fff;
  height: 40px;
  width: 40px;
  border-radius: 4px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  line-height: 36px;
`;

interface Props {
  defaultValue: number | string;
  handleInput?: (val: number) => void;
  handleIncrease: () => void;
  handleDecrease: () => void;
  showMax?: number | null;
}

const QtyChanger: React.FunctionComponent<Props> = ({
  defaultValue,
  handleInput,
  handleIncrease,
  handleDecrease,
  showMax,
}) => {
  let value;

  if (showMax) {
    value = defaultValue + ' / ' + showMax;
  } else {
    value = defaultValue;
  }

  return (
    <QtyWrapper>
      <QuantityButton onTouchStart={handleDecrease}>-</QuantityButton>
      <QuantityLabel>
        {value}
        {handleInput && (
          <Quantity
            value={defaultValue}
            inputMode="numeric"
            onChange={(e) => handleInput(parseInt(e.target.value, 10))}
          />
        )}
      </QuantityLabel>
      <QuantityButton onTouchStart={handleIncrease}>+</QuantityButton>
    </QtyWrapper>
  );
};

export default QtyChanger;
